import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const ACTIVITY = `/manage-activities`;
const ALL_MANAGE_ACTIVITIES = `/all-manage-activities`;

export const getActivityList = createAsyncThunk(
  "getActivityList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, search = "", activity_type = "", participation_level = "" } = values;
      const response = await http.get(`${ACTIVITY}?page=${page}&limit=${limit}&search=${search}&activity_type=${activity_type}&participation_level=${participation_level}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const archiveActivity = createAsyncThunk(
  "archiveActivity",
  async ({ uuid, archieve }: { uuid: any, archieve: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${ACTIVITY}/${uuid}`, { archieve });
      toast.success(response?.data?.message || "Activity archived Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive activity");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getActivityDetails = createAsyncThunk(
  "getActivityDetails",
  async ({ uuid }: { uuid: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${ACTIVITY}/${uuid}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to get mileage details");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateActivity = createAsyncThunk(
  "updateActivity",
  async ({ uuid, values }: { uuid: any, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${ACTIVITY}/${uuid}`, values);
      toast.success(response?.data?.message || "Activity updated Successfully.");
      dispatch(getActivityList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update activity");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addActivity = createAsyncThunk(
  "addActivity",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${ACTIVITY}`, values);
      toast.success(response?.data?.message || "Activity added Successfully.");
      dispatch(getActivityList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to add activity");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getAllActivityList = createAsyncThunk(
  "getActivityList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { search = ""} = values;
      const response = await http.get(`${ALL_MANAGE_ACTIVITIES}?search=${search}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);